import * as ActionTypes from "../ActionTypes";


export const GetTaxDeclarationAction = (params) => {
    return {
        type: ActionTypes.TAX_DECLARATION_GET_REQUEST,
        params
    }
}

export const AddTaxDeclarationAction = (params) => {
    return {
        type: ActionTypes.TAX_DECLARATION_ADD_REQUEST,
        params
    }
}

export const UpdateTaxDeclarationAction = (params) => {
    return {
        type: ActionTypes.TAX_DECLARATION_UPDATE_REQUEST,
        params
    }
}

export const GetTaxExecutiveAction = (params) => {
    return {
        type: ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_REQUEST,
        params
    }
}
export const UpdateTaxExecutiveAction = (params) => {
    return {
        type: ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_REQUEST,
        params
    }
}

export const GetTaxEmployeeToggleInfoAction = (params) => {
    return {
        type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_REQUEST,
        params
    }
}
export const UpdateTaxEmployeeToggleInfoAction = (params, callback) => {
    return {
        type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_REQUEST,
        params,
        callback
    }
}
